import { render, staticRenderFns } from "./FieldsetInvoiceHeader.yaml?vue&type=template&id=5422b6e2&component"
import script from "./FieldsetInvoiceHeader.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetInvoiceHeader.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports